import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAlgo = function SvgAlgo(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M60 120C27 120 0 93 0 59.701.3 26.701 27-.298 60.3.002c33 .3 59.7 27 59.7 60.6C119.7 93.3 93 120 60 120",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m40.37 90 8.678-15.026L57.725 60l8.624-15.026 1.429-2.381.635 2.38 2.645 9.895L68.095 60l-8.677 14.974L50.794 90h10.37l8.677-15.026 4.498-7.778 2.116 7.778L80.476 90h9.312l-4.02-15.026L81.745 60l-1.058-3.862 6.455-11.164h-9.418l-.318-1.112-3.28-12.275L73.704 30h-9.048l-.212.317-8.465 14.657L47.302 60l-8.625 14.974L30 90z"
    })));
};

export { SvgAlgo as ReactComponent };
//# sourceMappingURL=ALGO.svg.es.js.map
